/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `active` - aktywny
 * * `completed` - zrealizowany
 * * `abandoned` - porzucony
 */
export type GoalStatusEnum = typeof GoalStatusEnum[keyof typeof GoalStatusEnum];


export const GoalStatusEnum = {
  active: 'active',
  completed: 'completed',
  abandoned: 'abandoned',
} as const;
